import ReactMarkdown from "react-markdown";

export function MarkdownView({ text }: { text: string }) {
  return (
    <div className="prose prose-sm max-w-none font-mono text-[12.5px] leading-relaxed">
      <ReactMarkdown
        components={{
          h1: (props) => (
            <h1 className="font-display font-black uppercase text-2xl mt-3 mb-2 leading-tight" {...props} />
          ),
          h2: (props) => (
            <h2 className="font-display font-bold uppercase text-lg mt-3 mb-1.5 leading-tight text-paper" {...props} />
          ),
          h3: (props) => (
            <h3 className="font-display font-bold uppercase text-sm mt-2 mb-1 leading-tight" {...props} />
          ),
          p: (props) => <p className="my-1.5" {...props} />,
          ul: (props) => <ul className="list-none pl-0 space-y-0.5 my-1.5" {...props} />,
          ol: (props) => <ol className="list-decimal pl-5 space-y-0.5 my-1.5" {...props} />,
          li: ({ children, ...props }) => (
            <li className="flex items-start gap-1.5 before:content-['▪'] before:text-red before:mt-[1px]" {...props}>
              <span>{children}</span>
            </li>
          ),
          blockquote: (props) => (
            <blockquote className="border-l-2 border-red pl-3 my-2 italic font-serif text-paper" {...props} />
          ),
          code: (props: any) => {
            const inline = !String(props.children).includes("\n");
            return inline
              ? <code className="bg-ink/10 px-1 py-0.5 rounded text-[11px]" {...props} />
              : <code className="block bg-ink text-bone p-2 text-[11px] my-2 overflow-x-auto" {...props} />;
          },
          strong: (props) => <strong className="font-display font-bold text-ink" {...props} />,
          em: (props) => <em className="font-serif italic" {...props} />,
          hr: () => <hr className="border-t-2 border-ink/40 my-3" />,
          a: (props) => <a className="underline text-red hover:text-ink" target="_blank" rel="noreferrer" {...props} />
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
